// Reflet holo au survol des images produit : suit la souris en mettant à jour --mx / --my sur l'élément [data-holo].
// Uniquement avec une souris et sans prefers-reduced-motion (sinon le reflet reste masqué par holo-shine.css).
const HOLO_MEDIA_QUERY = '(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)';
const mediaQuery = window.matchMedia(HOLO_MEDIA_QUERY);

let frame = null;

function handlePointerMove(event) {
  if (!mediaQuery.matches || event.pointerType !== 'mouse') return;

  const element = event.target instanceof Element ? event.target.closest('[data-holo]') : null;
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
  const y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);

  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    element.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
    element.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
  });
}

// Module chargé une seule fois par page, même si plusieurs blocs l'appellent : un seul écouteur délégué
document.addEventListener('pointermove', handlePointerMove, { passive: true });
